import apiClient from './apiClient';

const assetService = {
  getAssets: (areaCode, search) =>
    apiClient.get('/api/v1/assets', {
      params: {
        ...(areaCode && { areaCode }),
        ...(search && { search }),
      },
    }),

  getAssetPriorities: () =>
    apiClient.get('/api/v1/assets/priorities'),

  getAutomatedFlowInsights: (assetId) =>
    apiClient.get(`/api/v1/assets/${assetId}/logs-events`),

  getSensorReadings: (assetId) =>
    apiClient.get(`/api/v1/assets/${assetId}/sensors`),

  getTechnicians: () =>
    apiClient.get('/api/v1/users/technicians'),

  getAssetSummary: (assetId) =>
    apiClient.get(`/api/v1/assets/${assetId}/summary`),

  getAlertHistory: (assetId) =>
    apiClient.get(`/api/v1/assets/${assetId}/alerts-history`),

  getFailureHistory: (assetId) =>
    apiClient.get(`/api/v1/assets/${assetId}/failures`),

  getServiceHistory: (assetId) =>
    apiClient.get(`/api/v1/assets/${assetId}/service-history`),

  getWorkOrders: (assetId) =>
    apiClient.get(`/api/v1/assets/${assetId}/work-orders`),

  getComments: (assetId) => 
    apiClient.get(`/api/v1/assets/${assetId}/comments`),

  addComment: (assetId, data) =>
    apiClient.post(`/api/v1/assets/${assetId}/comments`, data),

  diagnoseAsset: (assetId) =>
    apiClient.post(`/api/v1/assets/${assetId}/diagnose`, {}, {
      timeout: 10000
    }),

  pollDiagnosticStatus: (requestId) =>
    apiClient.get(`/api/v1/assets/diagnose/status/${requestId}`),

  createWorkOrder: (assetId, payload) =>
    apiClient.post(`/api/v1/assets/${assetId}/work-orders`, payload),
};

export default assetService;
